import React, { Component } from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import PropTypes from 'prop-types'
import { Header, Nav, Logo, NavLinks, MobileMenu, HamburgerMenu, CountrySelector, CountrySelectContainer } from './Navigation.style'
import NavigationItem from '../NavigationItem'
import WithIsScrolled from '../WithIsScrolled'
import CountrySelectorArrow from '../Icons/CountrySelectorArrow'
import { MENU_LINKS } from '../../../locales'

const HomeSlug = {
  slug: '/',
}

const PureNavigation = ({
  data,
  toggleMenu,
  menuOpen,
  lighttheme,
  sticky,
  className,
  switchCountry,
}) => {
  return (
    <Header sticky={sticky}>
      <Nav className={className}>
        <Link to="/" >
          <Logo display={sticky ? 'block' : lighttheme ? 'none' : 'block'} src={data.logo.imageFile.file.url} alt={data.logo.altText} title={data.logo.imageTitle} />
          <Logo display={sticky ? 'none' : lighttheme ? 'block' : 'none'} src={data.lightLogo.imageFile.file.url} alt={data.lightLogo.altText} title={data.lightLogo.imageTitle} />
        </Link>
        <NavLinks>
          {
            data.navigationItems.map(navItem => (
              <NavigationItem
                key={navItem.id}
                title={navItem.title}
                pageLink={navItem.pageLink}
                childItems={navItem.childItems}
                lighttheme={lighttheme}
                sticky={sticky}
              />
            ))
          }

          <CountrySelectContainer lighttheme={lighttheme}>
            <CountrySelector
              onChange={evt => switchCountry(evt)}
              aria-label="Select Country"
            >
              {
                data.countrySelector.map(item => {
                  return (
                    <option value={item.websiteUrl} key={item.id}>
                      {item.label}
                    </option>
                  )
                })}
            </CountrySelector>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.23 12.04">
              <CountrySelectorArrow />
            </svg>
          </CountrySelectContainer>
        </NavLinks>
        <HamburgerMenu
          lighttheme={lighttheme}
          onClick={toggleMenu}
          menuOpen={menuOpen}
          sticky={sticky}
        >
          <span />
          <span />
          <span />
          <span />
        </HamburgerMenu>
      </Nav>
      <MobileMenu menuOpen={menuOpen}>
        <NavigationItem
          title={MENU_LINKS.HOME}
          pageLink={HomeSlug}
        />
        {
          data.navigationItems.map(navItem => (
            <NavigationItem
              key={navItem.id}
              title={navItem.title}
              pageLink={navItem.pageLink}
              childItems={navItem.childItems}
              enableClick
            />
          ))
        }

        <CountrySelectContainer>
          <CountrySelector
            onChange={evt => switchCountry(evt)}
            aria-label="Select Country"
          >
            {
              data.countrySelector.map(item => {
                return (
                  <option value={item.websiteUrl} key={item.id}>
                    {item.label}
                  </option>
                )
              })}
          </CountrySelector>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.23 12.04">
            <CountrySelectorArrow />
          </svg>
        </CountrySelectContainer>
      </MobileMenu>
    </Header>
  )
}

class Navigation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false,
    }
  }

  switchCountry = selected => {
    window.location.href = selected.target.value
  }

  toggleMenu = () => {
    const { menuOpen } = this.state
    this.setState({
      menuOpen: !menuOpen,
    })
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query MenuQuery {
            allContentfulNavigationContainer {
              edges {
                node {
                  title
                  logo {
                    ...ImageFragment
                  }
                  lightLogo {
                    ...ImageFragment
                  }
                  navigationItems {
                    ...NavigationItemFragment
                  }
                  countrySelector {
                    id
                    label
                    websiteUrl
                  }
                }
              }
            }
          }
        `}
        render={({ allContentfulNavigationContainer }) => {
          const { menuOpen } = this.state
          const { lighttheme } = this.props

          return (
            <WithIsScrolled>
              {({ isScrolled }) => (
                <PureNavigation
                  data={allContentfulNavigationContainer.edges[0].node}
                  menuOpen={menuOpen}
                  sticky={isScrolled}
                  toggleMenu={this.toggleMenu}
                  lighttheme={lighttheme}
                  switchCountry={this.switchCountry}
                  className={isScrolled ? 'sticky-navitem' : ''}
                />
              )}
            </WithIsScrolled>
          )
        }}
      />
    )
  }
}

PureNavigation.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    logo: PropTypes.shape({
      imageFile: PropTypes.shape().isRequired,
    }).isRequired,
    lightLogo: PropTypes.shape({
      imageFile: PropTypes.shape().isRequired,
    }).isRequired,
    navigationItems: PropTypes.array.isRequired,
  }).isRequired,
  toggleMenu: PropTypes.func.isRequired,
  menuOpen: PropTypes.bool.isRequired,
  lighttheme: PropTypes.bool,
  sticky: PropTypes.bool.isRequired,
  className: PropTypes.string,
  switchCountry: PropTypes.func.isRequired,
}

PureNavigation.defaultProps = {
  lighttheme: false,
  className: '',
}

Navigation.propTypes = {
  lighttheme: PropTypes.bool,
}

Navigation.defaultProps = {
  lighttheme: false,
}

export default Navigation
